<template>
  <v-layout
    row
    align-center
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <div class="title">
            <h3 :style="titleStyle" class="headline mb-0">{{ $t('welcome') }}</h3>
          </div>
          <div class="mt-5">
            <h4 :style="titleStyle">Loading menu...</h4>
            <v-progress-linear :indeterminate="true" />
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  name: 'home-view',
  metaInfo () {
    return { title: this.$t('home') }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'gid', 'config'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    titleStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
  },
  beforeMount () {
    // await this.$store.dispatch('auth/fetchUser')
    if (!this.isMember && this.config.member_only) {
      this.$router.push({ name: 'login' })
    }
  },
  async mounted () {
    if (this.isMember) {
      this.$store.dispatch('cart/resetGuestDetails')
      await this.$store.dispatch('fetchMemberAll')
      await this.$store.dispatch('fetchMembershipInfo')
    }
    const iorderMToken = document.cookie.indexOf('iorder_m_token')
    if (Cookies.get(`iorder_m_token`) || iorderMToken !== -1) {
      // for timbre expo, hard code gems.iorder_group.id
      this.$router.push({ name: 'area1', params: { id: 14, is_expo: true }})
    } else {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
  margin-top: 65px;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue